import FeatureDialog, { Props as DialogProps } from 'stories/elements/Modal/DialogWindow/FeatureDialog'
import IssueSubjectIcon from 'assets/app/my_content/issue_subject.svg'

const SubjectSelectionDialog = ({ open, onClose, children, title, ...rest }: DialogProps) => {
    return (
        <FeatureDialog
            open={open}
            title={title}
            onClose={onClose}
            allowVerticalOverflow
            dialogIcon={<IssueSubjectIcon />}
            {...rest}
        >
            {children}
        </FeatureDialog>
    )
}

export default SubjectSelectionDialog
